<script setup lang="ts">
import type { Course } from '@/models/course';
import { onMounted, ref } from 'vue';
import { useCourseStore } from '@/stores/courseStore';
import SingleCourseElement from './singleCourseElement.vue';

const courseStore = useCourseStore();

const props = defineProps(["search", "category"]);
const isLoading = ref(true);

onMounted(async () => {
    try {
        await courseStore.getCourses(false, new Date());
    } finally {
        isLoading.value = false;
    }
});

const filterFunction = (o: Course) => {
    if(props.category && (o.categoryId?.indexOf(props.category) ?? -1) == -1)
       return false;
    if(!o.isVisible)
       return false;

    const x = o as any;
    return Object.keys(x).some(function(k) {
        if(x[k]){
            //console.log(JSON.stringify(x[k]));
            return JSON.stringify(x[k]).toLowerCase().indexOf(props.search.toLowerCase()) != -1;
        }
        return false;
    });
}
</script>

<template>
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 mt-6 sm:gap-10">
        <div v-if="isLoading" v-for="item in 6" :key="`course-skeleton-${item}`"
            class="mb-10 overflow-hidden rounded-xl border border-gray-300 bg-gray-300 shadow-lg sm:mb-0"
            aria-hidden="true">
            <div class="h-80 animate-pulse bg-gray-400"></div>
            <div class="space-y-3 px-4 py-6">
                <div class="mx-auto h-5 w-3/4 animate-pulse rounded bg-gray-400"></div>
                <div class="mx-auto h-4 w-1/2 animate-pulse rounded bg-gray-400"></div>
            </div>
        </div>
        <template v-for="course in courseStore.courses" :key="course.id">
            <single-course-element :course="course" v-if="!isLoading && filterFunction(course)"/>
        </template>
        <div v-if="!isLoading && courseStore.courses.length==0">
            {{ $t("courseList.empty") }}
        </div>
    </div>
</template>